import gql from 'graphql-tag'

export default gql`
  mutation addUsersToSubscription($users: [StripeUserInput]!) {
    addUsersToSubscription(users: $users) {
      success
      message
      emails
      clientSecret
      subscriptionId
      newUsersExceedSeats
      newQuantity
    }
  }
`
